import { container } from 'tsyringe';
class SetuptUnregisterInstance {
    static setup() {
        container.unregister = function (token) {
            this._registry.delete = function (key) {
                this._registryMap.delete(key);
            };
            const registration = this.getRegistration(token);
            if (!registration) {
                throw new Error(`Attempted to delete unregistered dependency token: "${token.toString()}"`);
            }
            this._registry.delete(token);
            if (this.interceptors.preResolution.has(token)) {
                this.interceptors.preResolution.delete(token);
            }
            if (this.interceptors.postResolution.has(token)) {
                this.interceptors.postResolution.delete(token);
            }
        };
    }
}
SetuptUnregisterInstance.setup();
